
import { createSlice } from "@reduxjs/toolkit";
import { del } from "framer-motion/client";

const initialState = {
    loading: false,
    error: null,
    raFavouriteReports: {
        data: [],
    },
    bdmFavouriteReports: {  
        data: [],
    },
    recruiterFavouriteReports: {
        data: [],
    },
    recruiterEmailDelivaryFavouriteReports: {
        data: [],
    }
}

const favouriteReportsSlice = createSlice({
    name: "favouriteReports",
    initialState,
    reducers: {
        raFavouriteReportsStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        raFavouriteReportsSuccess: (state, action) => {
            state.loading = false;
            state.raFavouriteReports.data = action.payload.data
        },
        raFavouriteReportsFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },
        addRaFavouriteReportStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        addRaFavouriteReportSuccess: (state, action) => {
            state.loading = false;
        },
        deleteRaFavouriteReportStart: (state, action) => {
            state.loading = true;
            state.error = null;
        },
        deleteRaFavouriteReportSuccess: (state, action) => {
            state.loading = false;
        },


        bdmFavouriteReportsStart: (state) => {
            state.loading = true;
        },
        bdmFavouriteReportsSuccess: (state, action) => {
            state.loading = false;
            state.bdmFavouriteReports.data = action.payload.data;
        },
        bdmFavouriteReportsFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },
        addBdmFavouriteReportStart: (state) => {
            state.loading = true;
        },
        addBdmFavouriteReportSuccess: (state, action) => {
            state.loading = false;
        },
        deleteBdmFavouriteReportStart: (state, action) => {
            state.loading = true;
            state.error = null;
        },
        deleteBdmFavouriteReportSuccess: (state, action) => {
            state.loading = false;
        },


        recruiterFavouriteReportsStart: (state) => {
            state.loading = true;
        },
        recruiterFavouriteReportsSuccess: (state, action) => {
            state.loading = false;
            state.recruiterFavouriteReports.data = action.payload.data;
        },
        recruiterFavouriteReportsFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },
        addRecruiterFavouriteReportStart: (state) => {
            state.loading = true;
        },
        addRecruiterFavouriteReportSuccess: (state, action) => {
            state.loading = false;
        },
        deleteRecruiterFavouriteReportStart: (state, action) => {
            state.loading = true;
            state.error = null;
        },
        deleteRecruiterFavouriteReportSuccess: (state, action) => {
            state.loading = false;
        },

        
        recruiterEmailDelivaryFavouriteReportsStart: (state) => {
            state.loading = true;
        },
        recruiterEmailDelivaryFavouriteReportsSuccess: (state, action) => {
            state.loading = false;
            state.recruiterEmailDelivaryFavouriteReports.data = action.payload.data;
        },
        recruiterEmailDelivaryFavouriteReportsFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload.error;
        },
        addRecruiterEmailDelivaryFavouriteReportStart: (state) => {
            state.loading = true;
        },
        addRecruiterEmailDelivaryFavouriteReportSuccess: (state, action) => {
            state.loading = false;
        },
        deleteRecruiterEmailDelivaryFavouriteReportStart: (state, action) => {
            state.loading = true;
            state.error = null;
        },
        deleteRecruiterEmailDelivaryFavouriteReportSuccess: (state, action) => {
            state.loading = false;
        },
    }
});

export const {
    raFavouriteReportsStart,
    raFavouriteReportsSuccess,
    raFavouriteReportsFailure,
    bdmFavouriteReportsStart,
    bdmFavouriteReportsSuccess,
    bdmFavouriteReportsFailure,
    recruiterFavouriteReportsStart,
    recruiterFavouriteReportsSuccess,
    recruiterFavouriteReportsFailure,
    recruiterEmailDelivaryFavouriteReportsStart,
    recruiterEmailDelivaryFavouriteReportsSuccess,
    recruiterEmailDelivaryFavouriteReportsFailure,
    addRaFavouriteReportStart,
    addRaFavouriteReportSuccess,
    addBdmFavouriteReportStart,
    addBdmFavouriteReportSuccess,
    addRecruiterFavouriteReportStart,
    addRecruiterFavouriteReportSuccess,
    addRecruiterEmailDelivaryFavouriteReportStart,
    addRecruiterEmailDelivaryFavouriteReportSuccess,
    deleteRaFavouriteReportStart,
    deleteRaFavouriteReportSuccess,
    deleteBdmFavouriteReportStart,
    deleteBdmFavouriteReportSuccess,
    deleteRecruiterFavouriteReportStart,
    deleteRecruiterFavouriteReportSuccess,
    deleteRecruiterEmailDelivaryFavouriteReportStart,
    deleteRecruiterEmailDelivaryFavouriteReportSuccess
} = favouriteReportsSlice.actions;

export default favouriteReportsSlice.reducer;